import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
	apiKey: 'AIzaSyDaynkBodh1duclW3pggJBdpHY-4p5ARb4',
	authDomain: 'your-social-dev.firebaseapp.com',
	projectId: 'your-social-dev',
	storageBucket: 'your-social-dev.appspot.com',
	messagingSenderId: '68126624876',
	appId: '1:68126624876:web:6e17bc03ba4cb0ff365c49',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
